import axios from "axios";
import store from "../store";

// axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

axios.interceptors.response.use(
  (response) => {
    const msg = (response.data?.msg || "").toLowerCase();

    if (response.data?.status === false && msg.includes("token")) {
      store.commit("SET_DIALOG_LOGOUT", true);
    }

    return response;
  },
  (error) => {
    store.commit("SET_ALERT", {
      show: true,
      msg: "Terjadi kesalahan koneksi. Coba lagi.",
      color: "error",
      position: "top",
    });

    return Promise.reject(error);
  }
);
export default axios;
